module.exports = __webpack_public_path__ + "static/media/boy.f514bbc7.png";